var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 8.1665H5.83325C5.52384 8.1665 5.22709 8.28942 5.0083 8.50821C4.7895 8.72701 4.66659 9.02375 4.66659 9.33317V24.4998C4.66659 24.8093 4.7895 25.106 5.0083 25.3248C5.22709 25.5436 5.52384 25.6665 5.83325 25.6665H22.1666C22.476 25.6665 22.7728 25.5436 22.9915 25.3248C23.2103 25.106 23.3333 24.8093 23.3333 24.4998V9.33317C23.3333 9.02375 23.2103 8.72701 22.9915 8.50821C22.7728 8.28942 22.476 8.1665 22.1666 8.1665Z",
    fill: "#F302CA",
    stroke: "#F302CA",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91659 10.4998V6.41646C9.91659 5.88023 10.0222 5.34925 10.2274 4.85384C10.4326 4.35843 10.7334 3.90828 11.1126 3.52911C11.4917 3.14994 11.9419 2.84916 12.4373 2.64396C12.9327 2.43875 13.4637 2.33313 13.9999 2.33313C14.5362 2.33313 15.0671 2.43875 15.5625 2.64396C16.058 2.84916 16.5081 3.14994 16.8873 3.52911C17.2664 3.90828 17.5672 4.35843 17.7724 4.85384C17.9776 5.34925 18.0833 5.88023 18.0833 6.41646V10.4998",
    stroke: "#F302CA",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/Marketplace.5c8fa74b26c3de874d9d90644948f207.svg";
export { ForwardRef as ReactComponent };